export function useHelpers() {
  const histogramas = [
    '0. Sem histórico de vendas',
    '1. Até 1 mês sem vender',
    '2. De 1 a 2 meses sem vender',
    '3. De 2 a 3 meses sem vender',
    '4. De 3 a 6 meses sem vender',
    '5. De 6 a 9 meses sem vender',
    '6. De 9 a 12 meses sem vender',
    '7. Acima de 12 meses sem vender',
  ];

  const niveis_servico = [
    '0. Nível Elevado',
    '1. Nível Alto',
    '2. Nível Médio',
    '3. Nível Baixo',
    '4. Nível Ordinário',
    '5. Sob Encomenda',
  ];

  const map_niveis_servico = {
    '5. Nível Elevado': 'NIVEL ELEVADO',
    '4. Nível Alto': 'NIVEL ALTO',
    '3. Nível Médio': 'NIVEL MEDIO',
    '2. Nível Baixo': 'NIVEL BAIXO',
    '1. Nível Ordinário': 'NIVEL ORDINARIO',
    '0. Sob Encomenda': 'SOB ENCOMENDA',
  };

  return {
    histogramas,
    niveis_servico,
    map_niveis_servico,
  }
}
